// extracted by mini-css-extract-plugin
export var quillEditor = "_jx-1";
export var variable = "_jx-0";